import { render, staticRenderFns } from "./serviceDoc.vue?vue&type=template&id=31eb12ca&scoped=true&"
import script from "./serviceDoc.vue?vue&type=script&lang=js&"
export * from "./serviceDoc.vue?vue&type=script&lang=js&"
import style0 from "./serviceDoc.vue?vue&type=style&index=0&id=31eb12ca&prod&scoped=true&lang=css&"
import style1 from "./serviceDoc.vue?vue&type=style&index=1&id=31eb12ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eb12ca",
  null
  
)

export default component.exports